export default __webpack_public_path__ + "static/media/person_6.282b02bd.jpg";